import { render, staticRenderFns } from "./ReplyExistingSpouseSupport.vue?vue&type=template&id=73174024"
import script from "./ReplyExistingSpouseSupport.vue?vue&type=script&lang=ts"
export * from "./ReplyExistingSpouseSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports